const POPULATE_CURRENCY = 'POPULATE_CURRENCY';

export function setCurrency(payload) {
    return { type: POPULATE_CURRENCY, payload };
}
